import {Component} from 'react'
import {
  ResultContainer,
  ChoicesContainer,
  ChoiceItem,
  ChoiceImage,
  ResultText,
  PlayAgainButton,
} from './styledComponents'

class ResultView extends Component {
  render() {
    const {yourChoice, opponentChoice, result, onPlayAgain} = this.props
    return (
      <ResultContainer>
        <ChoicesContainer>
          <ChoiceItem>
            <p>You</p>
            <ChoiceImage src={yourChoice.imageUrl} alt="your choice" />
          </ChoiceItem>
          <ChoiceItem>
            <p>Opponent</p>
            <ChoiceImage src={opponentChoice.imageUrl} alt="opponent choice" />
          </ChoiceItem>
        </ChoicesContainer>
        <ResultText>{result}</ResultText>
        <PlayAgainButton type="button" onClick={onPlayAgain}>
          PLAY AGAIN
        </PlayAgainButton>
      </ResultContainer>
    )
  }
}

export default ResultView
